import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const http = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

export const api = {
  getDomains: (lang) => http.get(`/domains`, { params: { lang } }).then((r) => r.data),
  createPlayer: (pseudo) => http.post(`/players`, { pseudo }).then((r) => r.data),
  getSession: (domaine, lang) =>
    http.get(`/events/session`, { params: { domaine, lang } }).then((r) => r.data),
  saveGame: (data) => http.post(`/games`, data).then((r) => r.data),
  getGame: (id) => http.get(`/games/${id}`).then((r) => r.data),
  getLeaderboard: (domaine) =>
    http.get(`/leaderboard`, { params: domaine ? { domaine } : {} }).then((r) => r.data),
  getRank: (playerId) => http.get(`/leaderboard/rank/${playerId}`).then((r) => r.data),
  trackShare: (gameId, plateforme) =>
    http.post(`/share/${gameId}/track`, { plateforme }).then((r) => r.data),
  challengeUrl: (gameId) => `${API}/c/${gameId}`,
  getLiveStats: () => http.get(`/stats/live`).then((r) => r.data),

  // Auth
  me: () => http.get(`/auth/me`).then((r) => r.data),
  postSession: (session_id) => http.post(`/auth/session`, { session_id }).then((r) => r.data),
  logout: () => http.post(`/auth/logout`).then((r) => r.data),

  // Skins + paiements
  getSkins: () => http.get(`/skins`).then((r) => r.data),
  checkout: (lookup_key, origin_url) =>
    http.post(`/payments/checkout`, { lookup_key, origin_url }).then((r) => r.data),
  paymentStatus: (sessionId) => http.get(`/payments/status/${sessionId}`).then((r) => r.data),
};

export const RANKS = {
  legende: { c1: "#f093fb", c2: "#f5576c", glow: "rgba(240,147,251,0.6)" },
  star: { c1: "#a855f7", c2: "#6366f1", glow: "rgba(168,85,247,0.6)" },
  connu: { c1: "#3b82f6", c2: "#06b6d4", glow: "rgba(59,130,246,0.6)" },
  anonyme: { c1: "#9ca3af", c2: "#4b5563", glow: "rgba(156,163,175,0.5)" },
};
